module.exports = __webpack_public_path__ + "img/edit.8359e925.svg";